import checkSchema from './check_schema';

function BookFormCtrl($scope, $uibModalInstance, model, company, title, successFn, $log) {
    'ngInject';

    $scope.loading = true;
    $scope.title = title;
    $scope.model = model;
    $scope.company = company;
    if ($scope.model.$has('new_booking')) {
        $scope.model.$get('new_booking').then((schema) => {
            $scope.form = _.reject(schema.form, x => x.type === 'submit');
            $scope.schema = checkSchema(schema.schema);
            $scope.form_model = {};
            return $scope.loading = false;
        });
    } else {
        $log.warn('model does not have \'new_booking\' rel');
    }

    $scope.submit = function (form) {
        $scope.$broadcast('schemaFormValidate');
        if (form.$valid) {
            $scope.loading = true;
            return $scope.company.$post('bookings', {}, $scope.form_model).then((booking) => {
                    $scope.loading = false;
                    $uibModalInstance.close(booking);
                    if (successFn) {
                        return successFn(booking);
                    }
                }
                , (err) => {
                    $scope.loading = false;
                    $uibModalInstance.close(err);
                    $log.error('Failed to create');
                    if (fail) {
                        return fail();
                    }
                });
        } else {
            return $log.warn('Invalid form');
        }
    };

    $scope.cancel = function (event) {
        event.preventDefault();
        event.stopPropagation();
        return $uibModalInstance.dismiss('cancel');
    };
}

export default BookFormCtrl;


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/modal_form/book_form.controller.js